import { ScrollTrigger } from 'gsap/ScrollTrigger';
import RytmWebflow from 'rytm-webflow';
import { trace } from 'rytm-helpers';
import { WCAG } from "rytm-wcag";

import { windowUpdate, removeReCaptchaBadge } from './shared/common';
import { initCarousels, destroyCarousels } from './shared/carousel';
// controllers
import Controller from './controllers/Controller';
import ImagesController from './controllers/ImagesController';
import LazyImagesController from './controllers/LazyImagesController';
import ChapterIntroController from './controllers/ChapterIntroController';
import ChapterObjectsController from './controllers/ChapterObjectsController';
// views
import HeaderPartView from './views/HeaderPartView';
import ImagesView from './views/ImagesView';
import NavNextView from './views/NavNextView';
import ChapterOpeningView from './views/ChapterOpeningView';
import ChapterContentView from './views/ChapterContentView';
import ChapterObjectsView from './views/ChapterObjectsView';
import ObjectListView from './views/ObjectListView';

const routes = {
  'webflow': {
    controller: Controller,
    view: RytmWebflow.WebflowView
  },
  'list': {
    controller: Controller,
    view: RytmWebflow.WebflowListView
  },
  'headerpart': {
    controller: Controller,
    view: HeaderPartView
  },
  'images': {
    controller: ImagesController,
    view: ImagesView,
  },
  'lazyImages': {
    controller: LazyImagesController,
    view: RytmWebflow.WebflowView,
  },
  // # Chapter
  'chapterIntro': {
    controller: ChapterIntroController,
    view: RytmWebflow.WebflowView,
  },
  'chapterOpening': {
    controller: Controller,
    view: ChapterOpeningView,
  },
  'chapterContent': {
    controller: Controller,
    view: ChapterContentView,
  },
  'chapterObjects': {
    controller: ChapterObjectsController,
    view: ChapterObjectsView,
  },
  // # nav next
  'navNext': {
    controller: Controller,
    view: NavNextView,
  },
  // # artobject
  'objectList': {
    controller: Controller,
    view: ObjectListView,
  },
}
const aswapProps = {
  animationTimeHide: 800,
  animationTimeShow: 800,
  preloadOnHover: false,
  cacheOn: true,
  refreshOnSameUrl: false,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    WCAG.onViewChanged();
    windowUpdate();
    initCarousels();
    RytmWebflow.showUp.rebuild();
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    // RytmWebflow.showUp.hide()
    RytmWebflow.bootsrap5.hideFlyovers()
  },
  onViewHidden: () => {
    // destroy...
    destroyCarousels();
    // kill all scroll triggers
    ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  },
  onRequestSameUrl: () => {
    // same url request
    RytmWebflow.bootsrap5.hideFlyovers();
  },
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents);
}